import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';
import axios from 'axios';

export const FETCH_OFFER_GROUP_REQUEST = 'FETCH_OFFER_GROUP_REQUEST';
export const FETCH_OFFER_GROUP_SUCCESS = 'FETCH_OFFER_GROUP_SUCCESS';
export const FETCH_OFFER_GROUP_ERROR = 'FETCH_OFFER_GROUP_ERROR';


export const GET_OFFER_GROUP_DETAIL_REQUEST =
    'GET_OFFER_GROUP_DETAIL_REQUEST';
export const GET_OFFER_GROUP_DETAIL_SUCCESS =
    'GET_OFFER_GROUP_DETAIL_SUCCESS';
export const GET_OFFER_GROUP_DETAIL_ERROR = 'GET_OFFER_GROUP_DETAIL_ERROR';

export const CREATE_OFFER_GROUP_REQUEST = 'CREATE_OFFER_GROUP_REQUEST';
export const CREATE_OFFER_GROUP_SUCCESS = 'CREATE_OFFER_GROUP_SUCCESS';
export const CREATE_OFFER_GROUP_ERROR = 'CREATE_OFFER_GROUP_ERROR';

export const UPDATE_OFFER_GROUP_REQUEST = 'UPDATE_OFFER_GROUP_REQUEST';
export const UPDATE_OFFER_GROUP_SUCCESS = 'UPDATE_OFFER_GROUP_SUCCESS';
export const UPDATE_OFFER_GROUP_ERROR = 'UPDATE_OFFER_GROUP_ERROR';

export const DELETE_OFFER_GROUP_REQUEST = 'DELETE_OFFER_GROUP_REQUEST';
export const DELETE_OFFER_GROUP_SUCCESS = 'DELETE_OFFER_GROUP_SUCCESS';
export const DELETE_OFFER_GROUP_ERROR = 'DELETE_OFFER_GROUP_ERROR';

export const FETCH_OFFER_GROUP_OPTIONS_REQUEST = 'FETCH_OFFER_GROUP_OPTIONS_REQUEST';
export const FETCH_OFFER_GROUPS_OPTIONS_SUCCESS = 'FETCH_OFFER_GROUPS_OPTIONS_SUCCESS';
export const FETCH_OFFER_GROUP_OPTIONS_ERROR = 'FETCH_OFFER_GROUP_OPTIONS_ERROR';

export const fetchOfferGroup = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                FETCH_OFFER_GROUP_REQUEST,
                FETCH_OFFER_GROUP_SUCCESS,
                FETCH_OFFER_GROUP_ERROR,
            ],
            callAPI: () => ApiClient.post('network/OfferGroup/Search', data),
            payload: { data },
        }),
    );
};

export const getOfferGroupDetail = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                GET_OFFER_GROUP_DETAIL_REQUEST,
                GET_OFFER_GROUP_DETAIL_SUCCESS,
                GET_OFFER_GROUP_DETAIL_ERROR,
            ],
            callAPI: () => ApiClient.get(`network/OfferGroup/${id}`),
            payload: { data: { id } },
        }),
    );
};

export const fetchOfferGroupOptions = () => dispatch => {
    return Promise.resolve().then(() =>
      dispatch({
        types: [
          FETCH_OFFER_GROUP_OPTIONS_REQUEST,
          FETCH_OFFER_GROUPS_OPTIONS_SUCCESS,
          FETCH_OFFER_GROUP_OPTIONS_ERROR,
        ],
        callAPI: () => ApiClient.get('network/OfferGroup/GetSelectList'),
        payload: {},
      }),
    );
};

export const createOfferGroup = (data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [
                CREATE_OFFER_GROUP_REQUEST,
                CREATE_OFFER_GROUP_SUCCESS,
                CREATE_OFFER_GROUP_ERROR,
            ],
            callAPI: () => ApiClient.post('network/OfferGroup', data),
            payload: { data, formId },
        }),
    );
};


export const updateOfferGroup = (id, data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [
                UPDATE_OFFER_GROUP_REQUEST,
                UPDATE_OFFER_GROUP_SUCCESS,
                UPDATE_OFFER_GROUP_ERROR,
            ],
            callAPI: () => ApiClient.put(`network/OfferGroup/${id}`, data),
            payload: { data: { ...data, id }, formId },
        }),
    );
};

export const deleteOfferGroup = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                DELETE_OFFER_GROUP_REQUEST,
                DELETE_OFFER_GROUP_SUCCESS,
                DELETE_OFFER_GROUP_ERROR,
            ],
            callAPI: () => ApiClient.delete(`network/OfferGroup/${id}`),
            payload: { data: { id } },
        }),
    );
};

const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
};

export default function reducer(state = initialState, action) {
    const { payload, response, error, successMessage, errorMessage } = action;
    switch (action.type) {
        case FETCH_OFFER_GROUP_REQUEST:
        case GET_OFFER_GROUP_DETAIL_REQUEST:
        case CREATE_OFFER_GROUP_REQUEST:
        case UPDATE_OFFER_GROUP_REQUEST:
        case DELETE_OFFER_GROUP_REQUEST:
        case FETCH_OFFER_GROUP_OPTIONS_REQUEST:
            return {
                ...state,
                payload,
                response: {},
                error: {},
                successMessage: '',
                errorMessage: '',
            };

            return {
                ...state,
                data: { ...state.data, options: response.data.data },
                response,
                successMessage,
            };

        case FETCH_OFFER_GROUP_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    items: response.data.data.items,
                    pages: response.data.data.pageCount,
                },
                response,
                successMessage,
            };

        case GET_OFFER_GROUP_DETAIL_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    item: response.data.data,
                },
                response,
                successMessage,
            };
        
        case FETCH_OFFER_GROUPS_OPTIONS_SUCCESS:
        return {
            ...state,
            data: { ...state.data, offerGroupOptions: response.data.data },
            response,
            successMessage,
        };

        case CREATE_OFFER_GROUP_SUCCESS:
        case UPDATE_OFFER_GROUP_SUCCESS:
        case DELETE_OFFER_GROUP_SUCCESS:
            return {
                ...state,
                response,
                successMessage,
            };

        case FETCH_OFFER_GROUP_ERROR:
        case GET_OFFER_GROUP_DETAIL_ERROR:
        case CREATE_OFFER_GROUP_ERROR:
        case UPDATE_OFFER_GROUP_ERROR:
        case DELETE_OFFER_GROUP_ERROR:
        case FETCH_OFFER_GROUP_OPTIONS_ERROR:
            return {
                ...state,
                payload,
                error,
                errorMessage,
            };
        default:
            return state;
    }
}
